'use client';

import React, { useState, useEffect } from 'react';
import { Button } from "@/components/base/buttons/button";
import { ModeToggle } from "@/components/mode-toggle";
import { cn } from "@/lib/utils";
import Link from 'next/link';
import { usePathname, useRouter } from 'next/navigation';
import BrandLogo from './BrandLogo';

const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const pathname = usePathname();
  const router = useRouter();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId) => {
    if (pathname !== '/') {
      router.push(`/#${sectionId}`);
    } else {
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  };

  return (
    <>
      {/* Top blur strip when header is floating */}


      <header
        className={cn(
          "fixed z-50 left-0 w-full flex items-center transition-all duration-300 transform-gpu",
          scrolled
            ? "top-0 h-[80px] bg-white/90 dark:bg-gray-950/90 backdrop-blur-md border-b border-gray-100 dark:border-gray-800 shadow-sm"
            : "top-0 h-[80px] bg-transparent border-transparent"
        )}
      >
        <div className="container flex justify-between items-center">
          <Link href="/" className="flex items-center gap-2 group" aria-label="Exibell Home">
            <BrandLogo
              textSize="text-xl"
              className="transition-transform group-hover:scale-[1.02]"
            />
          </Link>

          <div className="flex items-center gap-8 ml-auto">
            {/* <nav className="hidden md:flex items-center gap-8">
              <div className="flex items-center gap-1 cursor-pointer text-md font-semibold text-gray-600 dark:text-gray-400 hover:text-brand-700 dark:hover:text-brand-400 transition-colors">
                Resources
                <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" className="mt-0.5">
                  <path d="M3 4.5L6 7.5L9 4.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </div>
              <Link href="/company" className="text-md font-semibold text-gray-600 dark:text-gray-400 hover:text-brand-700 dark:hover:text-brand-400 transition-colors">
                About Us
              </Link>
            </nav> */}

            <div className="flex items-center gap-6">
              <Link href="/blog" className="text-sm font-semibold text-gray-600 dark:text-gray-400 hover:text-brand-700 dark:hover:text-brand-400 transition-colors">
                Blog
              </Link>
              <Button
                color="primary"
                size="md"
                onClick={() => scrollToSection('home-hero')}
                className="shadow-sm font-semibold"
              >
                Get Early Access
              </Button>
            </div>
          </div>
        </div>
      </header>
    </>
  );
};

export default Header;
